import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { BaseButton, rubikTypographyStyles } from '../../../shared/ui';
import { ReferralBonusTab } from '../model';

type ReferralBonusProgressTabsProps = {
  activeTab: ReferralBonusTab;
  onChange: (tab: ReferralBonusTab) => void;
};

const Tabs = styled.div.attrs({
  'data-ui': 'referral-bonus-progress-tabs',
})`
  width: ${({ theme }) => theme.scale.px(263)};
  min-height: ${({ theme }) => theme.scale.px(38)};
  justify-self: center;
  border-radius: ${({ theme }) => theme.scale.px(40)};
  background: ${({ theme }) => theme.colors.surface.subtle};
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: ${({ theme }) => theme.scale.px(5)};
  box-sizing: border-box;
  position: relative;
`;

const PillTrack = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.scale.px(5)};
  right: ${({ theme }) => theme.scale.px(5)};
  bottom: ${({ theme }) => theme.scale.px(5)};
  left: ${({ theme }) => theme.scale.px(5)};
  pointer-events: none;
`;

const ActivePill = styled.div<{ $activeTab: ReferralBonusTab }>`
  position: absolute;
  inset: 0;
  width: 50%;
  height: 100%;
  border-radius: ${({ theme }) => theme.scale.px(40)};
  background: ${({ theme }) => theme.colors.brand.primary};
  transform: ${({ $activeTab }) =>
    $activeTab === 'completed' ? 'translateX(100%)' : 'translateX(0)'};
  transition: transform 160ms ease;
`;

const TabButton = styled(BaseButton)<{ $isActive: boolean }>`
  ${rubikTypographyStyles};
  border-radius: ${({ theme }) => theme.scale.px(40)};
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.scale.px(14)};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.text.primary : theme.colors.border.emphasis};
  position: relative;
`;

export function ReferralBonusProgressTabs({
  activeTab,
  onChange,
}: ReferralBonusProgressTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs>
      <PillTrack>
        <ActivePill $activeTab={activeTab} />
      </PillTrack>
      <TabButton
        type="button"
        $isActive={activeTab === 'in-progress'}
        onClick={() => {
          onChange('in-progress');
        }}
      >
        {t('referralBonus.tabInProgress')}
      </TabButton>
      <TabButton
        type="button"
        $isActive={activeTab === 'completed'}
        onClick={() => {
          onChange('completed');
        }}
      >
        {t('referralBonus.tabCompleted')}
      </TabButton>
    </Tabs>
  );
}
